<template>
    <section id="list-notifications">
        <transition-group name="list" tag="div">
            <div 
                v-for="notification in data" 
                :key="notification" 
                class="notification-card list-item"
                :class="activeRemove == notification ? 'removeBlock' : (activeAdd == notification ? 'addBlock' : '')"
            >
                <!-- При клике должно происходить закрепление/открепление уведомления -->
                <span v-if="secured" class="notification-star" @click="unSecureNotification(notification)">
                    <mdicon name="star" width="14" height="14"/>
                </span>
                <span v-else class="notification-star" @click="secureNotification(notification)">
                    <mdicon name="star-outline" width="14" height="14"/>
                </span>
                <!-- Дата и время создания уведомления   -->
                <p>{{ notification.date }}</p>
                <div class="flex-between-block">
                    <!-- Краткое пояснение по требуемому действию   -->
                    <div class="left-notification-part">
                        <span>{{ notification.notification }}</span>
                    </div>
                    <div class="right-notification-part">
                        <div class="group-label-span">
                            <!-- Статус заказа -->
                            <label>Статус:</label>  
                            <span class="card-frame working">{{ notification.status }}</span>
                        </div>
                        <!-- При клике в отдельной вкладке браузера должен открываться заказ -->
                        <span class="card-frame btn-default ml-40" @click="openOrder(notification)" title="Перейти к заказу">Ознакомиться</span>
                    </div>
                </div>
            </div>
        </transition-group>
    </section>
</template>
<script>
export default {
    name: 'NotificationBlock',
    props: {
        data: Array,
        secured: Boolean
    },
    data() {
        return {
            activeRemove: "",
            activeAdd: "",
        }
    },
    methods: {
        // Закрепить уведомления
        secureNotification(notificationObj) {
            this.activeAdd = ""
            this.activeRemove = notificationObj
            this.$emit('secureNotification', notificationObj)
        },

        // Открепить
        unSecureNotification(notificationObj) {
            this.activeRemove = ""
            this.activeAdd = notificationObj
            this.$emit('unSecureNotification', notificationObj)
        },

        // Открыть в новом окне
        openOrder(notificationObj) {
            this.$emit('openOrder', notificationObj)
        },
    }
}
</script>

<style>
    .list-item {
        transition: all 0.5s;
    }
    .list-leave-to {
        opacity: 0;
        transform: translateY(20px);
    }
    .list-enter-to {
        opacity: 1;
    }
    .list-leave-active {
        /* position: absolute; */
        opacity: 0;
        transition: all 0.5s;
    }
    /* .list-enter-active {
        opacity: 0;
        position: absolute;
        transition: all 0.5s;
    } */
</style>